import { render, staticRenderFns } from "./TradersFeesBlock.vue?vue&type=template&id=75d7f484&scoped=true&"
import script from "./TradersFeesBlock.vue?vue&type=script&lang=js&"
export * from "./TradersFeesBlock.vue?vue&type=script&lang=js&"
import style0 from "./TradersFeesBlock.vue?vue&type=style&index=0&id=75d7f484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d7f484",
  null
  
)

export default component.exports